import useTranslation from "@babackapp/translations/use-translation";
import { Card, CardContent, CardHeader } from "@babackapp/ui/components/card";
import EditPasswordForm from "@/pages/(app)/account-settings/components/edit-password-form.tsx";
import EditNameForm from "@/pages/(app)/account-settings/components/edit-name-form.tsx";
import EditPictureProfileForm from "@/pages/(app)/account-settings/components/edit-picture-profile-form.tsx";
import { useAuth } from "@babackapp/auth-client/hooks";

export default function AccountSettingsPage() {
  const t = useTranslation();
  const { user } = useAuth();

  if (!user) {
    return;
  }

  return (
    <div
      className={
        "py-16 px-16 flex flex-col space-y-4 items-center justify-center w-full"
      }
    >
      <div className={"w-full max-w-[800px] space-y-4"}>
        <div className="flex flex-col gap-2 w-full">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            {t("accountSettings.title")}
          </h3>
          <p className="text-sm leading-relaxed text-muted-foreground max-w-[500px]">
            {t("accountSettings.subtitle")}
          </p>
        </div>
        <Card className={"w-full"}>
          <CardHeader>Profile</CardHeader>
          <CardContent>
            <EditPictureProfileForm user={user!} />
            <EditNameForm user={user!} />
          </CardContent>
        </Card>
        <Card className={"w-full"}>
          <CardHeader>Password</CardHeader>
          <CardContent>
            <EditPasswordForm />
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
